import { addMonths, dateToISODate } from "@amzn/storm-ui-date-picker";
import { DatePickerConfig } from "./interfaces";

export const datePickerConfigs: DatePickerConfig[] = [
    {
        id: 'start-date',
        labelKey: 'start-date-label',
        ariaLabelKey: 'select-start-date-aria-label',
        pickerId: 'start-date-picker',
        popoverId: 'start-date-popover',
    },
    {
        id: 'end-date',
        labelKey: 'end-date-label',
        ariaLabelKey: 'select-end-date-aria-label',
        pickerId: 'end-date-picker',
        popoverId: 'end-date-popover',
    },
];

export const getDatePickerProps = (
  isStartDate: boolean,
  startDate: Date,
  todayDate: Date
) => ({
  minDate: isStartDate ? todayDate : startDate,
  monthInView: !isStartDate && startDate ? dateToISODate(startDate) : undefined,
});
